import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0d5867f6&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=0d5867f6&prod&scoped=true&lang=scss"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=0d5867f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5867f6",
  null
  
)

export default component.exports